export const HomePageExplore = [
    {
        tag: 'Free',
        courses: [
            {
                heading: "Learn HTML",
                description: "Master the fundamentals of HTML to build and structure web pages with text, links, images, lists, and more.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Learn CSS",
                description: "Learn how to style websites using CSS, covering layout techniques, colors, typography, animations, and transitions.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Responsive Web design",
                description: "Understand responsive design principles to create web pages that adapt to different screen sizes and devices.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses: [
            {
                heading: "HTML",
                description: "Get started with HTML, learning how to create the structure of web pages using elements and attributes.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "CSS",
                description: "Discover how to make web pages visually appealing with CSS by applying styles and layouts effectively.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Responsive",
                description: "Learn the basics of building mobile-friendly websites using responsive design techniques with media queries.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Most popular',
        courses: [
            {
                heading: "Java",
                description: "Dive into Java programming, covering object-oriented principles, syntax, data structures, and basic algorithms.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Python",
                description: "Start coding with Python by exploring its syntax, control structures, data types, and real-world applications.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "SCSS",
                description: "Enhance your CSS skills with SCSS, learning about variables, nesting, mixins, and efficient styling workflows.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses: [
            {
                heading: "Flask",
                description: "Build web applications with Flask, a lightweight Python framework, and learn routing, templates, and APIs.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Django",
                description: "Learn to develop robust web apps with Django, focusing on models, views, templates, and authentication.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Fast API",
                description: "Create fast and scalable APIs using FastAPI with Python, emphasizing performance and easy integration.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Career paths',
        courses: [
            {
                heading: "Next.js",
                description: "Build server-rendered React applications with Next.js, focusing on routing, SSR, and performance optimization.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Nuxt.js",
                description: "Develop powerful Vue.js apps with Nuxt.js, leveraging SSR, static site generation, and modular architecture.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Sanity",
                description: "Learn to use Sanity, a headless CMS, for managing content and integrating with modern frontend frameworks.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
];
